import { render } from "./faq-group.vue?vue&type=template&id=06f11586&scoped=true&ts=true"
import script from "./faq-group.vue?vue&type=script&lang=ts"
export * from "./faq-group.vue?vue&type=script&lang=ts"

import "./faq-group.vue?vue&type=style&index=0&id=06f11586&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f11586"]])

export default __exports__